import React from 'react';
import DateRangeFilter from './Filters/DateRangeFilter';
import BranchFilter from './Filters/BranchFilter';
import ActivityFilter from './Filters/ActivityFilter';
import TherapeuticCategoryFilter from './Filters/TherapeuticCategoryFilter';
import PredictiveModelFilter from './Filters/PredictiveModelFilter';
import SaveFilterForm from './SaveFilterForm';
import useWorkQueue from '../hooks/useWorkQueue';
import AccordionWrapper from 'App/components/AccordionWrapper/AccordionWrapper';
import useIsPermitted from 'App/utils/hooks/useIsPermitted';
import { PERMISSION_TYPES } from 'App/utils/isPermitted';
import HeaderContent from './HeaderContent';
import DateRangeSelectFilter from './Filters/DateRangeSelectFilter';
import TherapeuticCategoryMultiSelectFilter from './Filters/TherapeuticCategoryMultiSelectFilter';
import BranchMultiSelectFilter from './Filters/BranchMultiSelectFilter';
import ActivityMultiSelectFilter from './Filters/ActivityMultiSelectFilter';
import PredictiveModelToggleFilter from './Filters/PredictiveModelToggleFilter';
import PatientLabelsFilter from './Filters/PatientLabelsFilter';
import styled from '@emotion/styled';
import PatientLabelsFilterWithExcludeToggle from './Filters/PatientLabelsFilterWithExcludeToggle';

const WorkQueueFiltersContainer = styled.div`
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
`;

const WorkQueueFilters = () => {
    useWorkQueue();
    const isWorkQueueFiltersEnabled = useIsPermitted(PERMISSION_TYPES.ENABLE_WORK_QUEUE_FILTERS);
    const isWorkQueueLabelsFilterEnabled = useIsPermitted(PERMISSION_TYPES.ENABLE_REACT_WORK_QUEUE_LABELS);

    const innerContent = (
        <div className="filter-section">
            <span className="filter-section-header filter-section-header-refine-by control-label">Filter By</span>
            <DateRangeFilter />
            <BranchFilter />
            <ActivityFilter />
            <PredictiveModelFilter />
            <TherapeuticCategoryFilter />
            {isWorkQueueLabelsFilterEnabled && <PatientLabelsFilter />}
            <SaveFilterForm />
        </div>
    );

    const innerContentWithFiltersFlag = (
        <WorkQueueFiltersContainer>
            <div className="filter-section search-filters">
                <DateRangeSelectFilter />
                <BranchMultiSelectFilter />
                <ActivityMultiSelectFilter />
                <PredictiveModelToggleFilter />
                <TherapeuticCategoryMultiSelectFilter />
                {isWorkQueueLabelsFilterEnabled && <PatientLabelsFilterWithExcludeToggle />}
            </div>
        </WorkQueueFiltersContainer>
    );

    return (
        <div>
            {isWorkQueueFiltersEnabled ? (
                <AccordionWrapper title="Filters" stateKey="workQueueFilters-toggle" HeaderContent={HeaderContent}>
                    {innerContentWithFiltersFlag}
                </AccordionWrapper>
            ) : (
                innerContent
            )}
        </div>
    );
};

export default WorkQueueFilters;
